function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.5,349.7c0-7.2-5.8-13-13-13h-6.8c-2.8-51-40.4-93.5-90.7-102.5l-2.3,12.8c42.8,7.8,75.3,42.9,79.7,86.2 c4.4,43.3-20.2,84.3-60.6,100.6c-2.5,1-4.1,3.4-4.1,6.1V467h-39.1v-19.5c0-3.6-2.9-6.5-6.5-6.5h-91.2c-3.6,0-6.5,2.9-6.5,6.5V467 h-39.1v-27.2c0-2.7-1.6-5-4.1-6C73.6,423,53,401,44.1,373.7c-0.9-2.7-3.4-4.5-6.2-4.5H13v-52.1h24.8c2.8,0,5.3-1.8,6.2-4.5 c9-27.3,29.6-49.3,56.2-60c2.5-1,4.1-3.4,4.1-6.1l-0.1-39.7c16.8,2.9,29.8,16.2,32.3,33c0.5,3.2,3.2,5.6,6.4,5.6h26.6v-13h-21.2 c-5-20.1-21.6-35.2-42-38.4c-3.7-0.6-7.5,0.4-10.3,2.9c-3,2.5-4.7,6.2-4.6,10.1v35.3c-26.8,12.1-47.7,34.3-58,61.8H13 c-7.2,0-13,5.8-13,13v52.1c0,7.2,5.8,13,13,13h20.2c10.4,27.5,31.2,49.7,58,61.8v23c0,7.2,5.8,13,13,13h39.1c7.2,0,13-5.8,13-13v-13 h78.2v13c0,7.2,5.8,13,13,13h39.1c7.2,0,13-5.8,13-13v-22.9c37.6-16.9,62.6-53.3,64.9-94.4h6.8v13c0,7.2,5.8,13,13,13h6.5v-13h-6.5 v-13H384.5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.9,303.4c-7.2-0.2-12.8-6.3-12.5-13.5l-13.1-0.4c-0.6,14.4,10.7,26.5,25,27.1c14.4,0.6,26.5-10.7,27.1-25l-13.1-0.4 C106.1,298,100,303.7,92.9,303.4z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.5,265h78.2v13h-78.2L182.5,265L182.5,265z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M374,10c-27.4,0-52.1,11.6-69.6,30.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.2,0.2-0.3,0.4-0.4,0.6C287.8,58.1,278,80.9,278,106 c0,52.9,43.1,96,96,96s96-43.1,96-96S426.9,10,374,10z M293.5,106c0-18.3,6.2-35.2,16.6-48.7L422.7,170 c-13.5,10.3-30.4,16.6-48.7,16.6C329.6,186.5,293.5,150.4,293.5,106z M434.1,159.4L320.6,45.9c14.2-12.7,32.9-20.5,53.4-20.5 c44.4,0,80.5,36.1,80.5,80.5C454.5,126.5,446.7,145.2,434.1,159.4z"
})));

var SvgNoFreeofcharge = function SvgNoFreeofcharge(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoFreeofcharge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-freeofcharge.71f8810b.svg";
export { ForwardRef as ReactComponent };